import { render, staticRenderFns } from "./invoiceSymbolsInfoBox.vue?vue&type=template&id=54d82f5a&"
import script from "./invoiceSymbolsInfoBox.vue?vue&type=script&lang=ts&"
export * from "./invoiceSymbolsInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports